import React from 'react';
import {useLocation} from "react-router-dom"
import whiteLogo from "../assets/images/logo-white.png"
import Strings from "../Lang/strings";
import {CheckIcon} from "@heroicons/react/solid";


const CompletedOrder = () => {
    const location = useLocation();
    if (!location.state?.completed) {
        return null;
    }
    return (
        <div className={"flex items-center w-full justify-center"}>
            <div className={"bg-talabatey-red rounded-2xl p-5 text-white"}>
                <img src={whiteLogo} alt="white colored talabatey logo"/>
                <div className={"flex items-center justify-center gap-x-2"}>
                    <h1 className={"text-4xl capitalize font-bold text-center"}>{Strings.completedOrder}</h1>
                    <CheckIcon className={"h-10 w-10 bg-green-600 rounded-full"}/>
                </div>
                <p className={"mt-1 text-gray-200 capitalize text-center"}>{Strings.simDelivered}</p>
            </div>
        </div>
    );
};

export default CompletedOrder;
